<template>
  <div class="alexa-callback-page">
    <div class="nav-bar">
      <span class="nav-title">{{ $t('将您的账户与Alexa关联') }}</span>
    </div>

    <!-- 关联中 -->
    <div v-if="status === 'loading'" class="content loading-content">
      <div class="toast-box">{{ $t('关联中') }}</div>
    </div>

    <!-- 关联成功 -->
    <div v-else-if="status === 'success'" class="content status-content">
      <img class="status-icon" :src="successIcon">
      <div class="status-title">{{ $t('恭喜！') }}</div>
      <div class="status-desc">{{ $t('Alexa绑定成功说明') }}</div>
    </div>

    <!-- 关联失败 -->
    <div v-else-if="status === 'error'" class="content status-content">
      <img class="status-icon" :src="errorIcon">
      <div class="status-title">{{ $t('关联失败，请重试') }}</div>
    </div>

    <!-- 底部按钮 -->
    <!-- <div v-if="status !== 'loading'" class="bottom-button">
      <div class="btn" @click="onButtonClick">{{ status === 'success' ? 'Back to Viomi' : 'Back to Alexa' }}</div>
    </div> -->
  </div>
</template>

<script>
import request from '@/utils/request'
import successIcon from '@/assets/imgs/ic_alexa_success.png'
import errorIcon from '@/assets/imgs/ic_alexa_error.png'
import store from '@/store/index'

export default {
  name: 'AlexaCallback',
  data() {
    return {
      status: 'loading',
      code: '',
      state: '',
      successIcon,
      errorIcon
    }
  },
  mounted() {
    this.parseParamsAndLanguage()
    console.log('this.code', this.code)
    console.log('this.state', this.state)
    if (this.code && this.state) {
      this.bindAccount()
    } else {
      this.status = 'error'
    }
  },
  methods: {
    parseParamsAndLanguage() {
      const query = this.$route ? { ...this.$route.query } : {}

      const searchParams = new URLSearchParams(window.location.search || '')
      searchParams.forEach((value, key) => {
        query[key] = value
      })

      const hash = window.location.hash
      const queryStr = hash.indexOf('?') !== -1 ? hash.substring(hash.indexOf('?')) : ''
      const hashParams = new URLSearchParams(queryStr)
      hashParams.forEach((value, key) => {
        query[key] = value
      })

      this.code = query.code || ''
      this.state = query.state || ''
      this.applyLanguage(query.lang)
    },

    applyLanguage(lang) {
      const supportLang = ['en_US', 'zh_CN', 'ko_KR']
      if (!supportLang.includes(lang)) {
        return
      }
      this.$store.dispatch('user/setLanguage', lang)
      this.$i18n.locale = lang
    },

    async bindAccount() {
      try {
        const res = await request({
          method: 'post',
          url: store.getters.homeBaseUrl + '/api/alexa/auth/bindAccount',
          data: {
            authorizationCode: this.code,
            state: this.state
          }
        })
        if (res.code === 100 && res.result) {
          this.status = 'success'
        } else {
          this.status = 'error'
        }
      } catch (e) {
        console.error('绑定失败:', e)
        this.status = 'error'
      }
    },

    onButtonClick() {
      window.history.back()
    }
  }
}
</script>

<style scoped>
.alexa-callback-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  background: #FFFFFF;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.nav-bar {
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFFFFF;
  font-size: 16px;
  font-weight: 600;
  color: #1F2226;
  flex-shrink: 0;
}

.content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 0 32px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.loading-content {
  align-items: center;
  justify-content: center;
}

.status-content {
  align-items: center;
  justify-content: flex-start;
  padding-top: 133px;
}

/* loading toast */
.toast-box {
  background: rgba(0, 0, 0, 0.7);
  color: #FFFFFF;
  font-size: 14px;
  padding: 10px 20px;
  border-radius: 8px;
}

/* 状态图标 */
.status-icon {
  width: 72px;
  height: 72px;
  margin-bottom: 16px;
}

/* 状态标题 */
.status-title {
  font-size: 20px;
  font-weight: 500;
  color: #17181A;
  margin-bottom: 16px;
  text-align: center;
}

/* 成功描述文字 */
.status-desc {
  font-size: 14px;
  color: #646567;
  text-align: left;
  line-height: 22px;
  align-self: center;
  width: 100%;
  padding: 0 32px;
}

/* 底部按钮区域 */
.bottom-button {
  padding: 12px 48px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
  flex-shrink: 0;
}

.btn {
  height: 48px;
  line-height: 48px;
  text-align: center;
  background: linear-gradient(135deg, #28BECA, #2DD4BF);
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 600;
  border-radius: 24px;
  letter-spacing: 0.5px;
}

.btn:active {
  opacity: 0.85;
}
</style>
